import React from 'react';
import './Speakers.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Adobe from '../../img/speakers/Adobe.png'
import Aijaz from '../../img/speakers/Aijaz.png'
import Amazon from '../../img/speakers/Amazon.png'
import Binkley from '../../img/speakers/Binkley.png'
import Camden from '../../img/speakers/Camden.png'
import De from '../../img/speakers/De.png'
import Gualino from '../../img/speakers/Gualino.png'
import HM from '../../img/speakers/HM.png'
import KarkinosHealthcare from '../../img/speakers/KarkinosHealthcare.png'
import Kaufman from '../../img/speakers/Kaufman.png'
import Localize from '../../img/speakers/Localize.png'
import NextInsurance from '../../img/speakers/NextInsurance.png'
import Pandey from '../../img/speakers/Pandey.png'
import PayPal from '../../img/speakers/PayPal.png'
import Salnikov from '../../img/speakers/Salnikov.png'
import Subramanian from '../../img/speakers/Subramanian.png'
import Goncharov from '../../img/speakers/Goncharov.png'
import Meta from '../../img/speakers/Meta.png'
import Richardson from '../../img/speakers/Richardson.png'
import Jetpackio from '../../img/speakers/Jetpackio.png'
import Kuncevic from '../../img/speakers/Kuncevic.png'
import AngularRocks from '../../img/speakers/AngularRocks.png'
import Ansari from '../../img/speakers/Ansari.png'
import Reactree from '../../img/speakers/Reactree.png'
import Andrzejewski from '../../img/speakers/Andrzejewski.png'
import VueStorefront from '../../img/speakers/VueStorefront.png'
import Castro from '../../img/speakers/Castro.png'
import VolkswagenDigitalSolutions from '../../img/speakers/VolkswagenDigitalSolutions.png'
import Fayock from '../../img/speakers/Fayock.png'
import Cloudinary from '../../img/speakers/Cloudinary.png'
import Benniks from '../../img/speakers/Benniks.png'
import Uniform from '../../img/speakers/Uniform.png'
import Duque from '../../img/speakers/Duque.png'
import Salesforce from '../../img/speakers/Salesforce.png'
import Afonso from '../../img/speakers/Afonso.png'
import OLXGroup from '../../img/speakers/OLXGroup.png'
import m4dz from '../../img/speakers/m4dz.png'
import RIOTS from '../../img/speakers/RIOTS.png'
import Leardini from '../../img/speakers/Leardini.png'
import Shiralizadeh from '../../img/speakers/Shiralizadeh.png'
import UCraft from '../../img/speakers/UCraft.png'
import Raymond from '../../img/speakers/Raymond.png'
import Bressi from '../../img/speakers/Bressi.png'
import Arabolaza from '../../img/speakers/Arabolaza.png'
import Valtech from '../../img/speakers/Valtech.png'
import Hush from '../../img/speakers/Hush.png'
import daily from '../../img/speakers/daily.png'
import wix from '../../img/speakers/wix.png'
import Brosset from '../../img/speakers/Brosset.png'
import Microsoft from '../../img/speakers/Microsoft.png'
import Urbanas from '../../img/speakers/Urbanas.png'
import Accenture from '../../img/speakers/Accenture.png'
import vmware from '../../img/speakers/vmware.png'
import appreal from '../../img/speakers/appreal.png'
import Avida from '../../img/speakers/Avida.png'
import Evinced from '../../img/speakers/Evinced.png'
import aijazVideo from '../../video/aijaz.mp4'
import andrzejewskiVideo from '../../video/andrzejewski.mp4'
import ansariVideo from '../../video/ansari.mp4'
import arabolazaVideo from '../../video/arabolaza.mp4'
import benniksVideo from '../../video/benniks.mp4'
import binkleyVideo from '../../video/binkley.mp4'
import afonsoVideo from '../../video/afonso.mp4'
import duqueVideo from '../../video/duque.mp4'
import bressiVideo from '../../video/bressi.mp4'
import camdenVideo from '../../video/camden.mp4'
import goncharovVideo from '../../video/goncharov.mp4'
import hushVideo from '../../video/hush.mp4'
import leardiniVideo from '../../video/leardini.mp4'
import m4dzVideo from '../../video/m4dz.mp4'
import raymondVideo from '../../video/raymond.mp4'
import salnikovVideo from '../../video/salnikov.mp4'
import urbanasVideo from '../../video/urbanas.mp4'
import SolotKehl from '../../img/speakers/SolotKehl.png'
import Lichter from '../../img/speakers/Lichter.png'
import developmint from '../../img/speakers/developmint.png'
import dolbyio from '../../img/speakers/dolbyio.png'
import PushBased from '../../img/speakers/PushBased.svg'
import Hladky from '../../img/speakers/Hladky.png'
import Clifford from '../../img/speakers/Clifford.png'
import influxdata from '../../img/speakers/influxdata.png'
import Steinkamp from '../../img/speakers/Steinkamp.png'
import Brand from '../../img/speakers/Brand.png'
import bright from '../../img/speakers/bright.png'
import extraordinarytogether from '../../img/speakers/extraordinarytogether.png'
import Boa from '../../img/speakers/Boa.png'
import ClaranetItalia from '../../img/speakers/ClaranetItalia.png'
import blackrock from '../../img/speakers/blackrock.png'

export default class SpeakersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listJunior: [
                {
                    track: 'Junior',
                    photo: Brand,
                    name: 'Akira Brand',
                    position: 'Dev Rel',
                    ln: 'https://www.linkedin.com/in/akirabrand/',
                    logo: bright,
                    title: `Security is Everybody's Job`,
                    abstract: `In DevOps, everyone performs security work, whether they like it or not. With a ratio of 100/10/1 for Development, Operations, and Security, it’s impossible for the security team alone to get it all done. We must build security into each of “the three ways”; automating and/or improving the efficiency of all security activities, speeding up feedback loops for security-related activities, and providing continuous learning opportunities in relation to security. While it may sound like the security team needs to learn to sprint, give feedback, and teach at the same time, the real challenge is creating a culture that embodies the mindset that security is everybody's job.`,
                },
                {
                    track: 'Junior',
                    photo: Kaufman,
                    name: 'Nir Kaufman',
                    position: 'Frontend Tech Lead',
                    website: 'https://nir.life/',
                    logo: NextInsurance,
                    title: 'Back to the future with BackboneJS!',
                    abstract: `MVC Frameworks used to rule the frontend development territory not so long ago. Today, it considered to be ""un-popular"". While all the major frameworks moved away from MV* patterns - It is still a valid pattern to a lot of applications out-here..
                    In this talk we will explore backboneJS - and see what can we learn from it in 2022`,
                },
                {
                    track: 'Junior',
                    video: salnikovVideo,
                    photo: Salnikov,
                    name: 'Maxim Salnikov',
                    position: 'Senior Developer Engagement Lead',
                    tw: 'https://twitter.com/webmaxru',
                    title: `Native Web Apps: Are We There Yet?`,
                    abstract: `There are so many discussions about web VS native apps. Will we get to the point where the Web becomes truly Native for the majority of the platforms? Progressive Web Apps, Project Fugu, WebAssembly & other technologies actively contribute to moving in this direction. In this session, we go through a list of details that make the integration of an application & operating system seamless, and map it to the APIs available for the web platform. With the knowledge of what's available today and what's coming soon, you are empowered to build truly Native Web Apps to deliver the best user experience!`,
                },
            ],
            listJuniorHide: [
                {
                    track: 'Junior',
                    photo: Subramanian,
                    name: 'Deepa Subramanian',
                    position: 'QE Developer',
                    tw: 'https://twitter.com/sdk_deepa',
                    logo: Adobe,
                    title: 'Building UI components using Storybook.js',
                    abstract: `Storybook is an open source tool for developing UI components in isolation for React, Vue, or Angular applications. Storybook.js makes building  organized and efficient UI. Developing reusable UI components it’s not as easy as you may think when you work in large teams. In this talk I will show you how to use Storybook with React application.`,
                },
                {
                    track: 'Junior',
                    photo: Steinkamp,
                    name: 'Zoe Steinkamp',
                    position: 'Developer Advocate',
                    logo: influxdata,
                    title: 'Unlocking Value from Time Series Data with Open Source Tools',
                    abstract: `Join Zoe Steinkamp, Developer Advocate at InfluxData, for a session where she will share how to take charge of your time series data with InfluxDB open source time series platform using JavaScript. In this session, you’ll learn how open source tools like Telegraf and InfluxDB can help you build real-time applications faster and with less effort. Zoe will also demo how to use InfluxDB to gain visibility and insight into your time-stamped data from the edge to the cloud.`,
                },
                {
                    track: 'Junior',
                    video: aijazVideo,
                    photo: Aijaz,
                    name: 'Rameez Aijaz',
                    position: 'SDE II',
                    ln: 'https://www.linkedin.com/in/rameez-aijaz',
                    logo: Amazon,
                    title: 'Webcomponents and their Applications',
                    abstract: `Some teams like to use React, Some like to use Vue, Some just go with Vanilla JavaScript and Some like to use Angular. Oftentimes in this kind of scenario, it gets really hard to reuse code from other team and to provide consistent user experience.

                Learn how webcomponents can help in providing consistent UI/UX in all products and in promoting reusability of code.`,
                },
                {
                    track: 'Junior',
                    video: duqueVideo,
                    photo: Duque,
                    name: 'Julián Duque',
                    position: 'Principal Developer Advocate',
                    tw: 'https://twitter.com/julian_duque',
                    logo: Salesforce,
                    title: 'Building an extensible CLI tool with oclif',
                    abstract: `In this talk you'll learn how to write extensible CLI tools with oclif, the Open CLI Framework. Learn how companies like Twilio, Salesforce, and Heroku rely on oclif to build their developer tools and provide a great developer experience.

                This talk will cover:
                * Introduction to oclif
                * Architecture a Command Line Application
                * Build a CLI tool with oclif using TypeScript
                * How to develop oclif plugins
                * How to release/publish your CLI`,
                },
                {
                    track: 'Junior',
                    video: camdenVideo,
                    photo: Camden,
                    name: 'Raymond Camden',
                    position: 'Senior Developer Evangelist',
                    tw: 'https://twitter.com/raymondcamden',
                    github: 'https://github.com/cfjedimaster',
                    logo: Adobe,
                    title: `A Beginner's Guide to Wrangling Asynchronicity in JavaScript`,
                    abstract: `In this talk, Raymond will talk about how to handle asynchronous code in JavaScript applications. He'll demonstrate the problems you encounter, the older style solutions (callbacks), and show how to use promises and async/await to make your code easier to work with. This will be a beginner's level topic with a focus on *practical* use cases but will wrap up with links to more solutions and advanced discussion.`,
                },
                {
                    track: 'Junior',
                    video: ansariVideo,
                    photo: Ansari,
                    name: 'Abdullah Ansari',
                    position: 'Co Founder and CTO',
                    ln: 'https://pk.linkedin.com/in/abdullah-ansari-137863171',
                    logo: Reactree,
                    title: 'Create your next application with Fauna db',
                    abstract: `As developers, we have all felt the need for front end databases at some point in time; one of the reasons being that it allows for rapid app development.
                The existing front-end databases, such as Firestore, are quite popular, but they have certain limitations which pose difficulty when structuring our queries.
                In this session, we will explore Fauna DB, a front-end database with GraphQL capabilities that has been built with modern apps in mind.
                We will also discuss how it is different from Firestore and at the end, we will also build a starter application with Fauna!`,
                },
                {
                    track: 'Junior',
                    photo: Castro,
                    name: 'Daniel Castro',
                    position: 'Frontend Software Developer',
                    ln: `https://www.linkedin.com/in/danieldmcastro/`,
                    github: 'https://github.com/Am4teur',
                    logo: VolkswagenDigitalSolutions,
                    title: 'NextJS credentials authentication with Nextauth',
                    abstract: `Authentication is often the starting point in modern web apps but it can be a long process. Using NextJS and Nextauth, we can shorten the authentication process to less than an hour, by having providers auth, like Github and Google, and the standard credentials auth. Also, we can know if a user is authenticated by accessing a session token, via hooks.`,
                },
                {
                    track: 'Junior',
                    video: binkleyVideo,
                    photo: Binkley,
                    name: 'Derek Binkley',
                    position: 'Full Stack Developer',
                    tw: 'https://twitter.com/DerekB_WI',
                    github: 'https://github.com/derek-b',
                    logo: Localize,
                    title: 'Build your first serverless API on AWS',
                    abstract: `You can create a professional grade API using serverless technology without cost and complexity
                of server configuration maintenance and deployment. In this talk we will
                see how to use the Serverless framework with AWS Lambda and Node.js to create
                a fully functioning and testable API. Using these tools we will learn how to configure our runtime
                environment in a way that we can setup and deploy with a single command. Once deployed our code
                will only run when invoked which means it can scale well without paying hosting fees for unused resources.
                
                At the end of this talk you will know what options are available to write and deploy a back end API that
                accepts requests, stores and searches data, and provides quick data access to our front end developers.`,
                },
                {
                    track: 'Junior',
                    video: afonsoVideo,
                    photo: Afonso,
                    name: 'Daniel Afonso',
                    position: 'Developer Advocate',
                    ln: 'https://www.linkedin.com/in/daniel-afonso-523a13155/',
                    tw: 'https://twitter.com/danieljcafonso',
                    logo: OLXGroup,
                    title: 'React Remixed',
                    abstract: `React and the JavaScript ecosystem seems to be constantly changing. Wherever we look, there are new libraries and frameworks. These new tools always lead to learning concepts that are often non-transferable knowledge.
                What if I told you that by learning standard web APIs, relearning the web, and getting a bunch of transferable knowledge, you can also start using a fantastic new addition to the React ecosystem: Remix!`,
                },
                {
                    track: 'Junior',
                    video: leardiniVideo,
                    photo: Leardini,
                    name: 'Francesco Leardini',
                    position: 'Principal Consultant and Trainer',
                    ln: 'https://www.linkedin.com/in/leardini81/',
                    tw: 'https://twitter.com/paco_ITA',
                    github: 'https://github.com/pacoita',
                    website: 'https://dev.to/paco_ita',
                    logo: Accenture,
                    title: 'Wait...can my browser do that?',
                    abstract: `We have new powerful instruments to leverage current web apps and provide a richer experience to our users. With the aim of modern web APIs, it is possible to design completely new functionalities and explore unique technological combinations, changing the way we develop and interact with web apps. We can directly use hardware devices and just through our browser! Let's explore some of the most exciting APIs and see how we can combine them to unlock new scenarios and give superpowers to our web apps.`,
                },
                {
                    track: 'Junior',
                    video: raymondVideo,
                    photo: Raymond,
                    name: 'Gadi Raymond',
                    position: 'Senior software developer',
                    ln: 'https://www.linkedin.com/in/gadi-raymond',
                    tw: 'https://twitter.com/gadiray',
                    logo: wix,
                    title: 'Full stack testing',
                    abstract: `The testing world has changed over the last years.
                The large ecosystem of JS produced some really helpful libraries that can help us write better tests.
                Whether it's Frontend, Backend, or E2E tests, I'll show you the test fundamentals you should follow.
                I'll cover some best practices and examples of Frontend, Backend, and E2E tests.
                Hopefully, it will improve your testing skills and help you in your next project.`,
                },
                {
                    track: 'Junior',
                    video: hushVideo,
                    photo: Hush,
                    name: 'James Hush',
                    position: 'Solutions Engineer',
                    ln: 'https://www.linkedin.com/in/jameshush/',
                    github: 'https://github.com/daily-co',
                    logo: daily,
                    title: 'Intro to WebRTC with DailyJS',
                    abstract: `Since the pandemic hit video conferencing has exploded in popularity. Even live events have transformed with many (including this one!) going virtual too. Creating live video experiences used to be impossible for a single developer. Until now.

                Join James Hush as he walks us through coding a WebRTC video call with DailyJS and vanilla JavaScript. He'll be putting the FUN in FUNdamentals, so no prior coding experience required!`,
                },
                {
                    track: 'Junior',
                    video: urbanasVideo,
                    photo: Urbanas,
                    name: 'Viktor Urbanas',
                    position: 'Node.js Tech Lead',
                    ln: 'https://www.linkedin.com/in/viktor-urbanas',
                    logo: appreal,
                    title: 'Understanding JavaScript iterators',
                    abstract: `We are going to talk about Javascript iterators. I noticed that many developers try avoid this part of Javascript because it is assumed to be a complex thing which not everyone understands. In fact iterators are very easy and once you figure them out you will be able to apply them in your day-to-day code which will bring it to the next level. We will dive into how iterators work and where you might have used them even without knowing. We also will look into few real examples of how you can apply them to solve your problems more elegantly.`,
                },
                {
                    track: 'Junior',
                    photo: Avida,
                    name: 'Asaf Shochet Avida',
                    position: 'Frontend Tech Lead',
                    ln: 'https://www.linkedin.com/in/asaf-shochet/',
                    website: 'https://www.frogrammer.net',
                    logo: Evinced,
                    title: 'Building an accessible component library from scratch',
                    abstract: `Creating web applications can be challenging. Creating accessible ones - even more so.
                However the real challenge lies in maintaining accessibility in your project since it requires knowledge and skills beyond those of traditional web development.
                To make this happen, one must choose the proper tools to keep the accessibility level high when code gets refactored, monitor the accessibility status and test it automatically during CI.
                
                To tackle these challenges, I’ll introduce a different approach that intertwines accessibility into the gut of the web application by creating an accessible components library.
                I’ll discuss the principles, tools and techniques I use to test and maintain the accessibility level over time, and provide you with the initial recipe to drive the accessibility change in your organization.`,
                },
                {
                    track: 'Junior',
                    photo: SolotKehl,
                    name: 'Griffin Solot-Kehl',
                    position: 'Developer Advocate',
                    tw: 'https://twitter.com/WingofaGriffin',
                    logo: dolbyio,
                    title: 'A browser based Metaverse with Babylon.js',
                    abstract: `This talk is centered around demonstrating how we are able to build immersive 3d environments all in JavaScript. I will show how we can build an interactive world in Babylon.js, and demo it working in real time.

                - Real time audio
                - Live streaming media
                - Increased engagement and retention of users
                - Broadcast quality workflows with low latency`,
                },
                {
                    track: 'Junior',
                    photo: Lichter,
                    name: 'Alexander Lichter',
                    position: 'Web Development Consultant',
                    ln: 'https://www.linkedin.com/in/alexanderlichter/',
                    tw: 'https://twitter.com/TheAlexLichter',
                    github: 'https://github.com/manniL/',
                    website: 'https://www.lichter.io/',
                    logo: developmint,
                    title: 'From ES6 to ESNext - JavaScript features you have to know',
                    abstract: `JavaScript is a language that is constantly evolving. Every year it gets new features and syntax updates. But with so many new features, it's easy to lose track.

                In this talk we'll look at which of the newer JavaScript features are helpful for your actual (daily) development and how to use them in different situations. Besides popular features, like Optional Chaining or Array Destructuring, we will also have a look at underrated additions to JavaScript that will still be beneficial for development.
                
                Eventually we will get into the process of how the language evolves, how proposals come up and how they'll be part of the language eventually.`,
                },
                // {
                //     track: 'Junior',
                //     photo: Richardson,
                //     name: 'Rob Richardson',
                //     position: '',
                //     ln: '',
                //     tw: '',
                //     github: '',
                //     website: '',
                //     logo: Jetpackio,
                //     title: '',
                //     abstract: ``,
                // },
            ],
            listSenior: [
                {
                    track: 'Senior',
                    video: goncharovVideo,
                    photo: Goncharov,
                    name: 'Andrey Goncharov',
                    position: 'Software Engineer',
                    tw: 'https://twitter.com/ai_goncharov',
                    github: 'https://github.com/aigoncharov',
                    website: 'https://goncharov.page/',
                    website2: 'https://blog.goncharov.page/',
                    logo: Meta,
                    title: 'Applied history of the front-end',
                    abstract: `New trends, frameworks, libraries come, revolutionize the industry and eventually die. Did you ever think why? What key ideas make them so popular? What fundamental problems do they have that force them to be replaced? 
                In this talk, we will create tiny live replicas of popular frameworks and libraries: starting from JQuery, ending with React. We are going to overview how they function, put them through various test scenarios, and reveal their bottlenecks. In the end, we will speculate about what the future might bring and try to peek into the front-end of tomorrow.`,
                },
                {
                    track: 'Senior',
                    photo: HM,
                    name: 'Hemanth HM',
                    position: 'Engineering Manager',
                    website: 'https://h3manth.com',
                    logo: PayPal,
                    title: 'ES?.next()',
                    abstract: `Does hearing about potential new features of Javascript excites you? Then this talk is for you! We will walk through a few interesting proposals from TC39 from stage-0 to stage-3. Let us see how beneficial these proposals are with code samples and some live coding.`,
                },
                {
                    track: 'Senior',
                    video: m4dzVideo,
                    photo: m4dz,
                    name: 'm4dz 🎙🥑',
                    position: 'Frontend Devtools Advocate',
                    ln: 'https://www.linkedin.com/in/m4d-z/',
                    tw: 'https://twitter.com/m4d_z',
                    github: 'https://github.com/m4dz/',
                    // logo: RIOTS,
                    title: 'SDKs vs Web Components: Place Your Bets',
                    abstract: `You're offering a fantastic brand new service, and it'll revolutionize your customers' world! Because it's smart, it delivers an API-first solution wrapped in an edge architecture. And because you're smart, you're offering to your end-users several SDKs to let them use those APIs at their full potential: PHP, Java, Ruby, Go, Python, JavaScript… Wait, JavaScript?

                When entering the world of frontend architecture in an API-first world, we should take time to answer this simple question: SDK or Web Components? The frontend world comes with a UI-first paradigm, so should we switch our mindset?
                
                On the other hand, Web Components now have a mature ecosystem where you can build advanced UI elements that already embed all the logic they need.
                
                API-first backend only requires HTTP streams, and Web Components embed the required network primitives. Should we distribute a JS SDK or a library of Web Components for our service? Here's the match between the two giants! SDKs vs Web Components: Place Your Bets.`,
                },
            ],
            listSeniorHide: [
                {
                    track: 'Senior',
                    photo: Fayock,
                    name: 'Colby Fayock',
                    position: 'Senior Developer Experience Engineer',
                    ln: 'https://www.linkedin.com/in/colbyfayock/',
                    tw: 'https://twitter.com/colbyfayock',
                    github: 'https://github.com/colbyfayock',
                    yb: 'https://youtube.com/colbyfayock',
                    logo: Cloudinary,
                    title: 'Full Stack Media with Next.js & Cloudinary',
                    abstract: `As the web becomes more visual, media is growingly becoming a vital part of any development project. From simply displaying images and videos to media management like uploading and organization, we need to build an app experience that matches our quality product.

                But how do we manage it all? Dev tech is a moving target, solidifying the need for manageable tooling, on top of needing the ability for our infrastructure components to easily communicate, providing a consistent experience for our visitors.
                
                We’ll see how we can take advantage of Next.js, a universal JavaScript framework, and Cloudinary, a media experience platform, to build full stack applications that leverage media to deliver high quality experiences for our visitors from secure uploads using serverless functions to displaying optimized images and video in our app.`,
                },
                {
                    track: 'Senior',
                    video: benniksVideo,
                    photo: Benniks,
                    name: 'Tim Benniks',
                    position: 'Principal developer advocate',
                    ln: 'https://www.linkedin.com/in/timbenniks/',
                    tw: 'https://twitter.com/timbenniks',
                    github: 'https://github.com/timbenniks',
                    website: 'https://timbenniks.dev',
                    logo: Uniform,
                    title: 'The modern digital pipeline, the future is composable.',
                    abstract: `Nowadays we are faced with an ever-expanding landscape of headless technologies like commerce, CMS, asset management, payments, and many more. All these services are API-first and this comes with a new paradigm: there is no more origin server. All the magic happens on the CDN and the CDN edge including serverless and workers. JavaScript sits at the centre of all this innovation.

                In this talk, we will use Nuxt 3 to wire up a modern Jamstack site (in a few Jamstack flavours - including edge rendering) that uses different headless sources AND personalization across these sources. 
                
                The goal: blazing fast sites, great DX, freedom of choice, and never re-platforming again...`,
                },
                {
                    track: 'Senior',
                    photo: Pandey,
                    name: 'Satyam Pandey',
                    position: 'Director Of Engineering',
                    ln: 'https://www.linkedin.com/in/satyam-pandey-339268176/',
                    logo: extraordinarytogether,
                    title: 'Optimization and State Management in MFE',
                    abstract: `Leveraging the state management for the micro-front styled architected application and finding the sweet spot for optimization.`,
                },
                {
                    track: 'Senior',
                    photo: De,
                    name: 'Dipanjan De',
                    position: 'Data Scientist',
                    ln: 'https://www.linkedin.com/in/dipanjan131/',
                    logo: KarkinosHealthcare,
                    title: 'Next Level User Experience with WebGL',
                    abstract: `Learn how to use WebGL libraries like ThreeJS in your projects to build amazing experience on your web and mobile applications. Add interactive 3D elements with amazing scenes and unleash your creativity on your next project.`,
                },
                {
                    track: 'Senior',
                    photo: Gualino,
                    name: 'Thomas Gualino',
                    position: 'Vice President',
                    ln: 'https://www.linkedin.com/in/thomasgualino/',
                    logo: blackrock,
                    title: 'SRE - Monitoring with JavaScript and Prometheus',
                    abstract: `SRE is a hot topic these days, but can prove difficult to approach. While everyone understands at high level what SRE means, very little people know what tools we have available and how to set it up a working solution with Javascript. This talk will try to provide an answer to these questions, by covering the main frameworks available out there and showing concrete examples.`,
                },
                {
                    track: 'Senior',
                    photo: Kuncevic,
                    name: 'Aliaksei Kuncevic',
                    position: 'Google Developer Expert',
                    tw: 'https://twitter.com/@kuncevic',
                    logo: AngularRocks,
                    title: 'Reactive programming in modern web',
                    abstract: `This talk is about the superpowers of Reactive Programming
                - Short history
                - Reactive programming implementations on different platforms
                - What problem does reactive programming solve
                - Basic operators
                - Real-world use cases
                - Demo`,
                },
                {
                    track: 'Senior',
                    video: andrzejewskiVideo,
                    photo: Andrzejewski,
                    name: 'Jakub Andrzejewski',
                    position: 'Senior Fullstack Developer',
                    ln: 'https://www.linkedin.com/in/jakub-andrzejewski/',
                    tw: 'https://twitter.com/jacobandrewsky',
                    github: 'https://github.com/Baroshem',
                    website: 'https://dev.to/jacobandrewsky',
                    logo: VueStorefront,
                    title: 'The future of E-Commerce is Open-Source and JavaScript 🚀',
                    abstract: `Building E-Commerce applications is not an easy task. And we at Vue Storefront managed to found it out in a hard way and these lessons we would like to share with you. Thankfully, there are several E-Commerce platforms as well as the Content Management Systems, that you can choose to easily build your Online Store. In this talk, I would like to guide you through the process of building an e-commerce website, what platforms are available, what is the concept of Headless Commerce and how we address it in Vue Storefront, and finally why I think that the future of E-Commerce lies in Open-Source and JavaScript.`,
                },
                {
                    track: 'Senior',
                    photo: Shiralizadeh,
                    name: 'Mohamad Shiralizadeh',
                    position: 'Architecture Owner',
                    ln: 'https://www.linkedin.com/in/shiralizadeh/',
                    logo: UCraft,
                    title: 'What is the the fastest JavaScript runtime? Is it Bun?',
                    abstract: `As you know recently, they introduced a new JavaScript runtime named Bun which is significantly faster than other runtimes. What I'm more excited about is what this tool can do to simplify your life as a developer!
                So, we're going to investigate its pros/cons and compare it to others.
                Stay tuned!`,
                },
                {
                    track: 'Senior',
                    video: bressiVideo,
                    photo: Bressi,
                    name: 'Claudia Bressi',
                    position: 'Senior Frontend Engineer',
                    logo: vmware,
                    title: 'Automating accessibility testing',
                    abstract: `When we work on accessibility tests, both manual and automatic testing are essentials. Often we have less time for manual procedures due to many other overwhelming tasks and tests throughout our day. In this talk we analyze a concrete use case and we'll show how to build effective strategies to automatize the accessibility testing. At the end we'll have in our hands a practical solution on how to integrate these procedures in our precious CI/CD pipeline.`,
                },
                {
                    track: 'Senior',
                    video: arabolazaVideo,
                    photo: Arabolaza,
                    name: 'Matias Arabolaza',
                    position: 'Principal Frontend Architect',
                    ln: 'https://www.linkedin.com/in/matiasarabolaza/',
                    logo: Valtech,
                    title: 'How to micro-frontend without loosing your mind',
                    abstract: `Have you heard about Micro Frontends and you don't know what they are? Are you curious about how micro-apps of different technology can leave together in the same website/application?

                Let's take a deep dive on how Micro Frontend really works and how can this architecture help you to make amazing apps without worry about the technology that each team is using!
                
                Because Micro Frontend is about collaboration.`,
                },
                {
                    track: 'Senior',
                    photo: Brosset,
                    name: 'Patrick Brosset',
                    position: 'Senior Product Manager',
                    tw: 'https://twitter.com/patrickbrosset',
                    website: 'https://patrickbrosset.com',
                    logo: Microsoft,
                    title: 'Building integrated desktop experiences with PWA',
                    abstract: `Does building native apps on desktop operating systems have to be frustrating and cost a fortune? Can't we just use the web to create native-like experiences on desktop?

                In this talk, we'll see how PWAs are revolutionizing the way we build and distribute highly capable apps on desktop OSes.
                
                We'll take a look at a demo and deep dive into code examples showing how to create a deeply integrated and native-like experience. With this talk, you'll feel excited about the future of the Web and motivated to build your next app.`,
                },
                {
                    track: 'Senior',
                    photo: Hladky,
                    name: 'Michael Hladky',
                    position: 'CEO, Push-Based',
                    ln: 'https://www.linkedin.com/in/michael-hladky-519340148',
                    tw: 'https://twitter.com/Michael_Hladky',
                    github: 'https://github.com/BioPhoton',
                    website: 'https://push-based.io',
                    logo: PushBased,
                    title: 'State of the Art DevTool Insights: Web Performance done right',
                    abstract: `Knowing how to run performance tests on your web application properly is one thing, and putting those metrics to good use is another. And both these aspects are crucial to the overall success of your performance optimization efforts. However, it can be quite an endeavor at times for it means you need to have a precise understanding of all the ins and outs of both performance data and performance tooling. This talk will shed light on how to overcome this challenge and walk you through the pitfalls and tricks of the trade of Chrome DevTools, providing you with a complete roadmap for performance analysis and optimization.`,
                },
                {
                    track: 'Senior',
                    photo: Boa,
                    name: 'Giorgio Boa',
                    position: 'Full stack developer',
                    ln: 'https://it.linkedin.com/in/giorgio-boa',
                    tw: 'https://twitter.com/giorgio_boa',
                    github: 'https://github.com/gioboa',
                    website: 'https://sessionize.com/giorgio-boa/',
                    logo: ClaranetItalia,
                    title: 'Micro-frontends with Svelte & Module Federation',
                    abstract: `Microservices nowadays is a well known concept and maybe you are using it in your current company.
                    Do you know that now you can apply similar ideas in the Frontend?
                    Today we already divide the Frontend into several components at development time, but at compile time these components are merged into one monolithic Frontend and this is where this new architecture comes into play.
                    In this talk we will understand the reasons behind micro-frontends and we will also explore one of the most interesting ways of applying them using Module Federation and Svelte`,
                },
                // {
                //     track: 'Senior',
                //     photo: Richardson,
                //     name: 'Rob Richardson',
                //     position: '',
                //     ln: '',
                //     tw: '',
                //     github: '',
                //     website: '',
                //     logo: Jetpackio,
                //     title: '',
                //     abstract: ``,
                // },
            ],
        }
    }

    render() {
        return (
            <div className="speakers" id='speakers'>
                <VideoPresent speakersJunior={this.state.listJunior} speakersSenior={this.state.listSenior} speakersJuniorHide={this.state.listJuniorHide} speakerSeniorHide={this.state.listSeniorHide} />
            </div>
        );
    }
};